import { Chip } from "@/components/atoms/Chip/Chip";
import "./ChipGroup.scss";

interface ChipGroupProps {
  activeTabId?: number | null;
  children?: React.ReactNode;
}

export const ChipGroup: React.FC<ChipGroupProps> = ({ children }) => {
  return <div className="chip-group">{children}</div>;
};
